export default "__VITE_ASSET__a840989c__"